import React, { Component } from 'react';
import BasicLayout from '../components/layout/BasicLayout';
import { API_ROOT, API_AUTH } from '../config';
import {
  Row,
  Col,
  Table,
  Popconfirm,
  message,
  Popover,
  Input,
  Button,
  Modal,
  Form,
  Select,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';
import { getNetwork } from '../utils/getNetwork';
const Search = Input.Search;

class CatalogsPage extends Component {
  constructor() {
    super();
    this.state = {
      categories: [],
      builders: [],
      eventNames: [],
      showAdd: false,
      showAddB: false,
      showEvent: false,
      // организации и их типы (AQ-275)
      organizationTypes: [],
      organizations: [],
      regions: [],
      localities: [],
      orgSearch: '',
      orgTypeModalVisible: false,
      orgTypeEditing: null,
      orgModalVisible: false,
      orgEditing: null,
    };
    this.orgTypeFormRef = React.createRef();
    this.orgFormRef = React.createRef();
    this.getData = this.getData.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleShowAdd = this.handleShowAdd.bind(this);
    this.handeShowEventName = this.handeShowEventName.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    getNetwork().post(API_ROOT + '/api/v1/roadway/workcategory/all').then((r) => {
      let categories = r.data;
      this.setState({ categories });
    });
    getNetwork().post(API_ROOT + '/api/v1/roadway/contractor/all').then((r) => {
      let builders = r.data;
      this.setState({ builders });
    });
    getNetwork().post(API_ROOT + '/api/v1/roadway/eventname/all').then((r) => {
      let eventNames = r.data;
      this.setState({ eventNames });
    });
    this.getOrgTypes();
    this.getOrganizations();
    this.getRegions();
  }

  // ===== Организации и типы организаций (AQ-275) =====

  getOrgTypes() {
    getNetwork()
      .get(API_AUTH + '/get/organization/type')
      .then((r) => this.setState({ organizationTypes: r.data || [] }));
  }

  getOrganizations() {
    getNetwork()
      .get(API_AUTH + '/get/organization')
      .then((r) => this.setState({ organizations: r.data || [] }));
  }

  getRegions() {
    getNetwork()
      .get(API_AUTH + '/get/regions')
      .then((r) => this.setState({ regions: r.data || [] }));
  }

  loadLocalities(regionId) {
    if (!regionId) {
      this.setState({ localities: [] });
      return Promise.resolve([]);
    }
    return getNetwork()
      .get(API_AUTH + '/get/locality/' + regionId)
      .then((r) => {
        const localities = r.data || [];
        this.setState({ localities });
        return localities;
      });
  }

  // --- типы организаций ---

  openOrgTypeModal(record) {
    this.setState({ orgTypeModalVisible: true, orgTypeEditing: record || null }, () => {
      if (!this.orgTypeFormRef.current) return;
      if (record) {
        this.orgTypeFormRef.current.setFieldsValue({
          nameRu: record.nameRu,
          nameKk: record.nameKk,
        });
      } else {
        this.orgTypeFormRef.current.resetFields();
      }
    });
  }

  closeOrgTypeModal() {
    this.setState({ orgTypeModalVisible: false, orgTypeEditing: null });
  }

  submitOrgType() {
    const { t } = this.props;
    const { orgTypeEditing } = this.state;
    this.orgTypeFormRef.current.validateFields().then((values) => {
      const payload = { nameRu: values.nameRu, nameKk: values.nameKk || '' };
      const request = orgTypeEditing
        ? getNetwork().put(API_AUTH + '/organization-type/' + orgTypeEditing.id, payload)
        : getNetwork().post(API_AUTH + '/organization-type', payload);
      request.then(() => {
        message.success(t('settingUpDirectories.saved'));
        this.closeOrgTypeModal();
        this.getOrgTypes();
      });
    });
  }

  removeOrgType(id) {
    const { t } = this.props;
    getNetwork()
      .delete(API_AUTH + '/organization-type/' + id)
      .then(() => {
        message.success(t('settingUpDirectories.removed'));
        this.getOrgTypes();
      })
      .catch(() => message.error(t('settingUpDirectories.cannotDelete')));
  }

  // --- организации ---

  openOrgModal(record) {
    if (record) {
      const regionId = record.region ? record.region.id : null;
      this.loadLocalities(regionId).then(() => {
        this.setState({ orgModalVisible: true, orgEditing: record }, () => {
          if (!this.orgFormRef.current) return;
          this.orgFormRef.current.setFieldsValue({
            nameRu: record.nameRu,
            nameKk: record.nameKk,
            orgTypeId: record.organizationType ? record.organizationType.id : undefined,
            regionId: regionId || undefined,
            localityId: record.locality ? record.locality.id : undefined,
          });
        });
      });
    } else {
      this.setState({ orgModalVisible: true, orgEditing: null, localities: [] }, () => {
        if (this.orgFormRef.current) this.orgFormRef.current.resetFields();
      });
    }
  }

  closeOrgModal() {
    this.setState({ orgModalVisible: false, orgEditing: null });
  }

  onRegionChange(regionId) {
    if (this.orgFormRef.current) {
      this.orgFormRef.current.setFieldsValue({ localityId: undefined });
    }
    this.loadLocalities(regionId);
  }

  submitOrg() {
    const { t } = this.props;
    const { orgEditing } = this.state;
    this.orgFormRef.current.validateFields().then((values) => {
      const payload = {
        nameRu: values.nameRu,
        nameKk: values.nameKk || '',
        regionId: values.regionId,
        orgTypeId: values.orgTypeId,
        localityId: values.localityId,
      };
      const request = orgEditing
        ? getNetwork().put(API_AUTH + '/organization/' + orgEditing.id, payload)
        : getNetwork().post(API_AUTH + '/organization', payload);
      request.then(() => {
        message.success(t('settingUpDirectories.saved'));
        this.closeOrgModal();
        this.getOrganizations();
      });
    });
  }

  removeOrg(id) {
    const { t } = this.props;
    getNetwork()
      .delete(API_AUTH + '/organization/' + id)
      .then(() => {
        message.success(t('settingUpDirectories.removed'));
        this.getOrganizations();
      })
      .catch(() => message.error(t('settingUpDirectories.cannotDelete')));
  }

  confirmDelete(id, type) {
    let { t } = this.props;
    let api = '/api/v1/roadway/workcategory/remove/';
    if (type === 'builder') {
      api = '/api/v1/roadway/contractor/remove/';
    } else if (type === 'eventName') {
      api = '/api/v1/roadway/eventname/remove/';
    }
    getNetwork().post(API_ROOT + api + id).then(() => {
      message.success(t('settingUpDirectories.removed'));
      this.getData();
    });
  }

  handleSearchChange(val) {
    this.setState({ showAdd: val });
  }

  handleShowAdd(val) {
    this.setState({ showAddB: val });
  }

  handeShowEventName(val) {
    this.setState({ showEvent: val });
  }

  addCategory(val) {
    let { t } = this.props;
    let api = '/api/v1/roadway/workcategory/save';
    getNetwork().post(API_ROOT + api + '?nameRu=' + val).then(() => {
      message.success(t('settingUpDirectories.addedBy'));
      this.getData();
      this.setState({ showAdd: false });
    });
  }
  addBuilder(val) {
    let { t } = this.props;
    let api = '/api/v1/roadway/contractor/save';
    getNetwork().post(API_ROOT + api + '?nameRu=' + val).then(() => {
      message.success(t('settingUpDirectories.addedBy'));
      this.getData();
      this.setState({ showAddB: false });
    });
  }

  addEventName(val) {
    let { t } = this.props;
    let api = '/api/v1/roadway/eventname/save';
    getNetwork().post(API_ROOT + api + '?nameRu=' + val).then(() => {
      message.success(t('settingUpDirectories.addedBy'));
      this.getData();
      this.setState({ showEvent: false });
    });
  }

  render() {
    let { t } = this.props;
    const columnsCat = [
      {
        title: t('settingUpDirectories.name'),
        dataIndex: 'nameRu',
        key: 'nameRu',
      },
      {
        title: '',
        key: 'action',
        render: (text, record) => (
          <span>
            <Popconfirm
              title={t('settingUpDirectories.exactlyWantToDelete') + '?'}
              onConfirm={() => this.confirmDelete(record.id, 'category')}
              okText={t('settingUpDirectories.yes')}
              cancelText={t('settingUpDirectories.no')}
            >
              <a href="javascript:void(0)">
                {t('settingUpDirectories.delete')}
              </a>
            </Popconfirm>
          </span>
        ),
      },
    ];
    const columnsBuilder = [
      {
        title: t('settingUpDirectories.name'),
        dataIndex: 'nameRu',
        key: 'nameRu',
      },
      {
        title: '',
        key: 'action',
        render: (text, record) => (
          <span>
            <Popconfirm
              title={t('settingUpDirectories.exactlyWantToDelete') + '?'}
              onConfirm={() => this.confirmDelete(record.id, 'builder')}
              okText="Да"
              cancelText="Нет"
            >
              <a href="javascript:void(0)">
                {t('settingUpDirectories.delete')}
              </a>
            </Popconfirm>
          </span>
        ),
      },
    ];
    const columnsEventname = [
      {
        title: t('settingUpDirectories.name'),
        dataIndex: 'nameRu',
        key: 'nameRu',
      },
      {
        title: '',
        key: 'action',
        render: (text, record) => (
          <span>
            <Popconfirm
              title={t('settingUpDirectories.exactlyWantToDelete') + '?'}
              onConfirm={() => this.confirmDelete(record.id, 'eventName')}
              okText={t('settingUpDirectories.yes')}
              cancelText={t('settingUpDirectories.no')}
            >
              <a href="javascript:void(0)">
                {t('settingUpDirectories.delete')}
              </a>
            </Popconfirm>
          </span>
        ),
      },
    ];

    const columnsOrgType = [
      {
        title: t('settingUpDirectories.name'),
        dataIndex: 'nameRu',
        key: 'nameRu',
      },
      {
        title: '',
        key: 'action',
        width: 160,
        render: (text, record) => (
          <span>
            <a
              href="javascript:void(0)"
              onClick={() => this.openOrgTypeModal(record)}
              style={{ marginRight: 16 }}
            >
              {t('settingUpDirectories.edit')}
            </a>
            <Popconfirm
              title={t('settingUpDirectories.exactlyWantToDelete') + '?'}
              onConfirm={() => this.removeOrgType(record.id)}
              okText={t('settingUpDirectories.yes')}
              cancelText={t('settingUpDirectories.no')}
            >
              <a href="javascript:void(0)">{t('settingUpDirectories.delete')}</a>
            </Popconfirm>
          </span>
        ),
      },
    ];

    const columnsOrg = [
      {
        title: t('settingUpDirectories.name'),
        dataIndex: 'nameRu',
        key: 'nameRu',
      },
      {
        title: t('settingUpDirectories.organizationType'),
        key: 'orgType',
        render: (text, record) =>
          record.organizationType ? record.organizationType.nameRu : '',
      },
      {
        title: t('settingUpDirectories.region'),
        key: 'region',
        render: (text, record) => (record.region ? record.region.nameRu : ''),
      },
      {
        title: '',
        key: 'action',
        width: 160,
        render: (text, record) => (
          <span>
            <a
              href="javascript:void(0)"
              onClick={() => this.openOrgModal(record)}
              style={{ marginRight: 16 }}
            >
              {t('settingUpDirectories.edit')}
            </a>
            <Popconfirm
              title={t('settingUpDirectories.exactlyWantToDelete') + '?'}
              onConfirm={() => this.removeOrg(record.id)}
              okText={t('settingUpDirectories.yes')}
              cancelText={t('settingUpDirectories.no')}
            >
              <a href="javascript:void(0)">{t('settingUpDirectories.delete')}</a>
            </Popconfirm>
          </span>
        ),
      },
    ];

    const orgSearch = (this.state.orgSearch || '').toLowerCase();
    const filteredOrganizations = orgSearch
      ? this.state.organizations.filter((o) =>
          (o.nameRu || '').toLowerCase().includes(orgSearch)
        )
      : this.state.organizations;

    const orgTypeOptions = this.state.organizationTypes.map((item) => ({
      label: item.nameRu,
      value: item.id,
    }));
    const regionOptions = this.state.regions.map((item) => ({
      label: item.nameRu,
      value: item.id,
    }));
    const localityOptions = this.state.localities.map((item) => ({
      label: item.nameRu,
      value: item.id,
    }));

    return (
      <BasicLayout>
        <Row gutter={16}>
          <Col className="gutter-row" span={12}>
            <h4>{t('settingUpDirectories.categoryReference')}</h4>
            <Table
              rowKey={(record) => record.id}
              columns={columnsCat}
              dataSource={this.state.categories}
              title={() => {
                return (
                  <Popover
                    placement="right"
                    content={
                      <Search
                        placeholder={t('settingUpDirectories.enterNewCategory')}
                        onSearch={(value) => this.addCategory(value)}
                        enterButton={t('settingUpDirectories.addTo')}
                      />
                    }
                    trigger="click"
                    visible={this.state.showAdd}
                    onVisibleChange={this.handleSearchChange}
                  >
                    <Button
                      icon={<PlusOutlined />}
                      onClick={() => this.handleSearchChange(true)}
                    />
                  </Popover>
                );
              }}
            />
          </Col>
          <Col className="gutter-row" span={12}>
            <h4>{t('settingUpDirectories.contractorsDirectory')}</h4>
            <Table
              rowKey={(record) => record.id}
              columns={columnsBuilder}
              dataSource={this.state.builders}
              title={() => {
                return (
                  <Popover
                    placement="right"
                    content={
                      <Search
                        placeholder={t('settingUpDirectories.enterNewCategory')}
                        onSearch={(value) => this.addBuilder(value)}
                        enterButton={t('settingUpDirectories.plus')}
                      />
                    }
                    trigger="click"
                    visible={this.state.showAddB}
                    onVisibleChange={this.handleShowAdd}
                  >
                    <Button
                      icon={<PlusOutlined />}
                      onClick={() => this.handleShowAdd(true)}
                    />
                  </Popover>
                );
              }}
            />
          </Col>
          <Col className="gutter-row" span={12}>
            <h4>{t('settingUpDirectories.responsibleDirectory')}</h4>
            <Table
              rowKey={(record) => record.id}
              columns={columnsEventname}
              dataSource={this.state.eventNames}
              title={() => {
                return (
                  <Popover
                    placement="right"
                    content={
                      <Search
                        placeholder={t('settingUpDirectories.enterResponsible')}
                        onSearch={(value) => this.addEventName(value)}
                        enterButton={t('settingUpDirectories.addTo')}
                      />
                    }
                    trigger="click"
                    visible={this.state.showEvent}
                    onVisibleChange={this.handeShowEventName}
                  >
                    <Button
                      icon={<PlusOutlined />}
                      onClick={() => this.handeShowEventName(true)}
                    />
                  </Popover>
                );
              }}
            />
          </Col>
          <Col className="gutter-row" span={12}>
            <h4>{t('settingUpDirectories.organizationTypesDirectory')}</h4>
            <Table
              rowKey={(record) => record.id}
              columns={columnsOrgType}
              dataSource={this.state.organizationTypes}
              title={() => (
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => this.openOrgTypeModal(null)}
                />
              )}
            />
          </Col>
          <Col className="gutter-row" span={12}>
            <h4>{t('settingUpDirectories.organizationsDirectory')}</h4>
            <Table
              rowKey={(record) => record.id}
              columns={columnsOrg}
              dataSource={filteredOrganizations}
              title={() => (
                <Row justify="space-between" align="middle" gutter={8}>
                  <Col>
                    <Button
                      icon={<PlusOutlined />}
                      onClick={() => this.openOrgModal(null)}
                    />
                  </Col>
                  <Col flex="auto" style={{ maxWidth: 260, marginLeft: 8 }}>
                    <Input.Search
                      allowClear
                      placeholder={t('settingUpDirectories.search')}
                      onChange={(e) => this.setState({ orgSearch: e.target.value })}
                    />
                  </Col>
                </Row>
              )}
            />
          </Col>
        </Row>

        <Modal
          title={
            this.state.orgTypeEditing
              ? t('settingUpDirectories.editOrganizationType')
              : t('settingUpDirectories.addOrganizationType')
          }
          visible={this.state.orgTypeModalVisible}
          onOk={() => this.submitOrgType()}
          onCancel={() => this.closeOrgTypeModal()}
          okText={t('settingUpDirectories.save')}
          cancelText={t('settingUpDirectories.cancel')}
          forceRender
          destroyOnClose={false}
        >
          <Form ref={this.orgTypeFormRef} layout="vertical">
            <Form.Item
              name="nameRu"
              label={t('settingUpDirectories.nameRu')}
              rules={[{ required: true, message: t('settingUpDirectories.enterName') }]}
            >
              <Input placeholder={t('settingUpDirectories.enterName')} />
            </Form.Item>
            <Form.Item name="nameKk" label={t('settingUpDirectories.nameKk')}>
              <Input placeholder={t('settingUpDirectories.enterName')} />
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title={
            this.state.orgEditing
              ? t('settingUpDirectories.editOrganization')
              : t('settingUpDirectories.addOrganization')
          }
          visible={this.state.orgModalVisible}
          onOk={() => this.submitOrg()}
          onCancel={() => this.closeOrgModal()}
          okText={t('settingUpDirectories.save')}
          cancelText={t('settingUpDirectories.cancel')}
          forceRender
          destroyOnClose={false}
        >
          <Form ref={this.orgFormRef} layout="vertical">
            <Form.Item
              name="nameRu"
              label={t('settingUpDirectories.nameRu')}
              rules={[{ required: true, message: t('settingUpDirectories.enterName') }]}
            >
              <Input placeholder={t('settingUpDirectories.enterName')} />
            </Form.Item>
            <Form.Item
              name="nameKk"
              label={t('settingUpDirectories.nameKk')}
              rules={[{ required: true, message: t('settingUpDirectories.enterName') }]}
            >
              <Input placeholder={t('settingUpDirectories.enterName')} />
            </Form.Item>
            <Form.Item
              name="orgTypeId"
              label={t('settingUpDirectories.organizationType')}
              rules={[{ required: true, message: t('settingUpDirectories.selectType') }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                placeholder={t('settingUpDirectories.selectType')}
                options={orgTypeOptions}
                filterOption={(input, option) =>
                  (option.label || '').toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
            <Form.Item
              name="regionId"
              label={t('settingUpDirectories.region')}
              rules={[{ required: true, message: t('settingUpDirectories.selectRegion') }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                placeholder={t('settingUpDirectories.selectRegion')}
                options={regionOptions}
                onChange={(value) => this.onRegionChange(value)}
                filterOption={(input, option) =>
                  (option.label || '').toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
            <Form.Item
              name="localityId"
              label={t('settingUpDirectories.locality')}
              rules={[{ required: true, message: t('settingUpDirectories.selectLocality') }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                disabled={this.state.localities.length === 0}
                placeholder={t('settingUpDirectories.selectLocality')}
                options={localityOptions}
                filterOption={(input, option) =>
                  (option.label || '').toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Form>
        </Modal>
      </BasicLayout>
    );
  }
}
export default withTranslation()(CatalogsPage);
